import { createGlobalStyle } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from '../theme';
export const BaseStyle = createGlobalStyle `
  *, *::before, *::after {
    box-sizing: inherit;
    line-height: ${theme.lineHeight.default};
  }

  html {
    font-family: ${theme.fontFamily.default};
    font-size: 100%;
    font-style: normal;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-size-adjust: 100%;
    box-sizing: border-box;
    border-collapse: collapse;
  }

  html, body {
    color: ${theme.semantic.foreground.primary};
    background-color: ${theme.semantic.surface.primary};	
  }

  html, body, .app-root {
    width: 100%;
    min-height: 100vh;
  }

  body {
    margin: 0;
  }

  main {
    display: block;
  }

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }

  pre {
    /* stylelint-disable-next-line font-family-no-duplicate-names -- normalize.css: fixes odd 'em' font sizing in all browsers */
    font-family: monospace, monospace;
    font-size: 1em;
  }

  a {
    background-color: transparent;
    text-decoration: none;
  }

  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }

  b,
  strong {
    font-weight: bolder;
  }

  code,
  kbd,
  samp {
    /* stylelint-disable-next-line font-family-no-duplicate-names -- normalize.css: fixes odd 'em' font sizing in all browsers */
    font-family: monospace, monospace;
    font-size: 1em;
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 1;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  img {
    border-style: none;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1;
    margin: 0;
  }

  button,
  input {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    /* stylelint-disable-next-line declaration-property-value-keyword-no-deprecated -- normalize.css: corrects the inability to style clickable types in iOS/Safari */
    appearance: button;
  }

  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }

  progress {
    vertical-align: baseline;
  }

  textarea {
    overflow: auto;
  }

  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }

  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }

  [type='search'] {
    appearance: textfield;
    outline-offset: ${pxToRem(-2)};
  }

  [type='search']::-webkit-search-decoration {
    appearance: none;
  }

  ::-webkit-file-upload-button {
    /* stylelint-disable-next-line declaration-property-value-keyword-no-deprecated -- normalize.css: corrects the inability to style clickable types in iOS/Safari */
    appearance: button;
    font: inherit;
  }

  details {
    display: block;
  }

  summary {
    display: list-item;
  }

  template {
    display: none;
  }

  [hidden] {
    display: none;
  }

  strong {
    font-weight: ${theme.fontWeight.medium};
  }

  ul, ol, menu {
    list-style: none;
  }

  ul, ol, li, menu, dl, dd {
    margin: 0;
    padding: 0;
  }

  * {
    margin-block-end: 0;
  }

  input[type="search"] {
    border-radius: 0;
    appearance: none;
  }

  button {
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;
    background: transparent;
    color: inherit;
    font: inherit;
    line-height: normal;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
    appearance: none;
  }
`;
